import Vue from 'vue';
import Router from 'vue-router';
import IndexPage from '../pages';
import ValidateEmailPage from '../pages/validate-email/validate-email';
import EndUserAgreementPage from '../pages/end-user-agreement/end-user-agreement';
import Callback from '../pages/callback/callback';
import CallbackPopup from '../pages/callback/popup';

Vue.use(Router);

export default new Router({
    // mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: IndexPage
        },
        {
            path: '/validate-email',
            name: 'validateEmail',
            component: ValidateEmailPage,
            props: (route) => ({
                token: route.query.token
            })
        },
        {
            path: '/end-user-agreement',
            name: 'endUserAgreement',
            component: EndUserAgreementPage
        },
        {
            path: '/callback',
            name: 'callback',
            component: Callback
        },
        {
            path: '/callback/popup',
            name: 'callbackPopup',
            component: CallbackPopup
        }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js